import { Tramitation } from "@/models/tramitation";
import { TramitationAPI } from "@/api/tramitation.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Viproc } from "@/models/viproc";

const tramitationApi = new TramitationAPI();

const findByViproc = (
  process: string,
  page?: number,
  size?: number
): AxiosObservable<Tramitation> => {
  const split = process.split("/");
  const number = Number(split[0]);
  const year = Number(split[1]);

  const viproc = new Viproc(number, year);

  return tramitationApi.findByViproc(viproc, page, size);
};

const findByProcessoId = (
  process: number,
  page?: number,
  size?: number
): AxiosObservable<Tramitation> => {
  return tramitationApi.findByProcessoId(process, page, size);
};

export default { findByViproc, findByProcessoId };
